/**
 * #privatemessages_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../../google/protobuf/empty.js";
import { Listing } from "../common/common_msg.js";
import { ComposeRequest, GenericPrivateMessagesRequest, MessageWhereRequest, ReadAllMessagesRequest, } from "./privatemessages_msg.js";
export const PrivateMessagesServiceName = "devvit.plugin.redditapi.privatemessages.PrivateMessages";
export class PrivateMessagesClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || PrivateMessagesServiceName;
        this.rpc = rpc;
        this.Block = this.Block.bind(this);
        this.CollapseMessage = this.CollapseMessage.bind(this);
        this.Compose = this.Compose.bind(this);
        this.DelMsg = this.DelMsg.bind(this);
        this.ReadAllMessages = this.ReadAllMessages.bind(this);
        this.ReadMessage = this.ReadMessage.bind(this);
        this.UnblockSubreddit = this.UnblockSubreddit.bind(this);
        this.UncollapseMessage = this.UncollapseMessage.bind(this);
        this.UnreadMessage = this.UnreadMessage.bind(this);
        this.MessageWhere = this.MessageWhere.bind(this);
    }
    Block(request, metadata) {
        const data = GenericPrivateMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Block", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    CollapseMessage(request, metadata) {
        const data = GenericPrivateMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "CollapseMessage", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    Compose(request, metadata) {
        const data = ComposeRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Compose", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    DelMsg(request, metadata) {
        const data = GenericPrivateMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DelMsg", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    ReadAllMessages(request, metadata) {
        const data = ReadAllMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ReadAllMessages", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    ReadMessage(request, metadata) {
        const data = GenericPrivateMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ReadMessage", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UnblockSubreddit(request, metadata) {
        const data = GenericPrivateMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnblockSubreddit", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UncollapseMessage(request, metadata) {
        const data = GenericPrivateMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UncollapseMessage", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UnreadMessage(request, metadata) {
        const data = GenericPrivateMessagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnreadMessage", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    MessageWhere(request, metadata) {
        const data = MessageWhereRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "MessageWhere", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
}
export const PrivateMessagesDefinition = {
    name: "PrivateMessages",
    fullName: "devvit.plugin.redditapi.privatemessages.PrivateMessages",
    methods: {
        /** https://www.reddit.com/dev/api#POST_api_block */
        block: {
            name: "Block",
            requestType: GenericPrivateMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([12, 18, 10, 47, 97, 112, 105, 47, 98, 108, 111, 99, 107]),
                        new Uint8Array([2, 24, 3]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_collapse_message */
        collapseMessage: {
            name: "CollapseMessage",
            requestType: GenericPrivateMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            28,
                            18,
                            26,
                            47,
                            97,
                            112,
                            105,
                            47,
                            99,
                            111,
                            108,
                            108,
                            97,
                            112,
                            115,
                            101,
                            95,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_compose */
        compose: {
            name: "Compose",
            requestType: ComposeRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([14, 18, 12, 47, 97, 112, 105, 47, 99, 111, 109, 112, 111, 115, 101]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_del_msg */
        delMsg: {
            name: "DelMsg",
            requestType: GenericPrivateMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            19,
                            18,
                            17,
                            47,
                            97,
                            112,
                            105,
                            47,
                            100,
                            101,
                            108,
                            95,
                            109,
                            115,
                            103,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_read_all_messages */
        readAllMessages: {
            name: "ReadAllMessages",
            requestType: ReadAllMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            29,
                            18,
                            27,
                            47,
                            97,
                            112,
                            105,
                            47,
                            114,
                            101,
                            97,
                            100,
                            95,
                            97,
                            108,
                            108,
                            95,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            115,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_read_message */
        readMessage: {
            name: "ReadMessage",
            requestType: GenericPrivateMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            24,
                            18,
                            22,
                            47,
                            97,
                            112,
                            105,
                            47,
                            114,
                            101,
                            97,
                            100,
                            95,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_unblock_subreddit */
        unblockSubreddit: {
            name: "UnblockSubreddit",
            requestType: GenericPrivateMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            29,
                            18,
                            27,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            110,
                            98,
                            108,
                            111,
                            99,
                            107,
                            95,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_uncollapse_message */
        uncollapseMessage: {
            name: "UncollapseMessage",
            requestType: GenericPrivateMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            30,
                            18,
                            28,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            110,
                            99,
                            111,
                            108,
                            108,
                            97,
                            112,
                            115,
                            101,
                            95,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_unread_message */
        unreadMessage: {
            name: "UnreadMessage",
            requestType: GenericPrivateMessagesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            26,
                            18,
                            24,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            110,
                            114,
                            101,
                            97,
                            100,
                            95,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_message_where */
        messageWhere: {
            name: "MessageWhere",
            requestType: MessageWhereRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            115,
                            18,
                            113,
                            47,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            47,
                            123,
                            119,
                            104,
                            101,
                            114,
                            101,
                            125,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            109,
                            97,
                            114,
                            107,
                            61,
                            123,
                            109,
                            97,
                            114,
                            107,
                            125,
                            38,
                            109,
                            105,
                            100,
                            61,
                            123,
                            109,
                            105,
                            100,
                            125,
                            38,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                    ],
                },
            },
        },
    },
};
